import type { Entry } from "contentful";
import type { TypeButtonSkeleton, TypeExternalButtonSkeleton } from "@/types/contentful/generated";
import { mapEntryExperiences, type VariantData } from "./mapEntryExperiences";

type ButtonEntry = Entry<TypeButtonSkeleton, undefined, string>;
type ExternalButtonEntry = Entry<TypeExternalButtonSkeleton, undefined, string>;

type CtaFields = ButtonEntry["fields"] | ExternalButtonEntry["fields"];

export type CtaVariantData = VariantData<CtaFields>;
export type CtaContentTypeId = "button" | "externalButton";

export const mapCtaExperiences = (experiences: unknown[] | undefined, variantContentType: CtaContentTypeId) =>
  mapEntryExperiences<CtaFields>(experiences, variantContentType);
